import { render, staticRenderFns } from "./YourIngredientsChart.vue?vue&type=template&id=6fd1a88e&scoped=true&"
import script from "./YourIngredientsChart.vue?vue&type=script&lang=js&"
export * from "./YourIngredientsChart.vue?vue&type=script&lang=js&"
import style0 from "./YourIngredientsChart.vue?vue&type=style&index=0&id=6fd1a88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1a88e",
  null
  
)

export default component.exports